import CrmQuote from '../../CrmQuote';

const RaApiQuoteMapperV1 = {
  mapJsonToQuote: (parsedQuoteJson) => new CrmQuote(
    parsedQuoteJson.id,
    parsedQuoteJson.status,
    parsedQuoteJson.createdAt,
    parsedQuoteJson.grandTotal,
    parsedQuoteJson.tax,
    parsedQuoteJson.shippingAddress,
    parsedQuoteJson.billingAddress,
    parsedQuoteJson.productSpecialist,
    parsedQuoteJson.quoteLineItemList ? parsedQuoteJson.quoteLineItemList : [],
    parsedQuoteJson.expiresAt,
    parsedQuoteJson.shippingCost,
    parsedQuoteJson.shippingCarrier,
    parsedQuoteJson.shippingMethod,
    parsedQuoteJson.currency,
    parsedQuoteJson.crmOrgId,
    parsedQuoteJson.needsShipping,
  ),
};

export default RaApiQuoteMapperV1;
